(function () {
  'use strict';

  window.imageSwap = {
    initialise: function () {
      this.$images = $('.bont-multi-product-img-container');
      this._waitForApoToLoad();
    },

    _waitForApoToLoad: function () {
      const pollingInterval = 500;
      const maxAttempts = 20;
      let attemptCount = 0;

      const apoCheckInterval = setInterval(() => {
        attemptCount++;
        const apoLoaded = $('.mw-apo-container').length > 0;

        if (apoLoaded || attemptCount >= maxAttempts) {
          clearInterval(apoCheckInterval);
          document.querySelectorAll('.hidden-until-apo-loads').forEach(el => {
            el.classList.remove('hidden-until-apo-loads');
          });
          this._initializeImageSwap();
        }
      }, pollingInterval);
    },

    _initializeImageSwap: function () {
      this._selectFirstVariant();
      this._bindOptionChangeEventHandlers();
      this._setInitialImage();
    },

    _selectFirstVariant: function () {
      const $selectedVariant = $('input[type="radio"][name="Color"]:checked');
      if ($selectedVariant.length === 0) {
        const $firstVariant = $('input[type="radio"][name="Color"]').first();
        if ($firstVariant.length) {
          $firstVariant.prop('checked', true).trigger('change');
        }
      }
    },

    _setInitialImage: function () {
      const selectedVariant = this._getSelectedVariant();
      const productTags = window.productTags || [];
      const isMybonts = productTags.includes('image-swap-mybonts');

      if (selectedVariant) {
        this._displayMainVariantImage();
        this._displaySelectedOptionImages();
      } else {
        const $firstImage = this.$images.first();
        $firstImage.css({
          'z-index': isMybonts ? 'auto' : '1',
          'opacity': '1'
        });
      }
    },

    _bindOptionChangeEventHandlers: function () {
      $('input[type="radio"][name="Color"]').on('change click touchstart pointerdown touchend', this._onColorChange.bind(this));
      $('input[type="radio"][name^="mw_opts"], select[name^="mw_opts"]').on('change click touchstart pointerdown touchend', this._onOptionChange.bind(this));
    },

    _onColorChange: function () {
      this._displayMainVariantImage();
      this._logSelectedMwApoVariant();
    },

    _onOptionChange: function () {
      this._displaySelectedOptionImages();
      this._logSelectedMwApoVariant();
    },

    _displayMainVariantImage: function () {
      const selectedVariant = this._getSelectedVariant();
      if (!selectedVariant) return;

      const productTags = window.productTags || [];
      const isMybonts = productTags.includes('image-swap-mybonts');

      this.$images.css({ 'z-index': '0', 'opacity': '0' });
      let mainImageFound = false;

      this.$images.each(function () {
        const $this = $(this);
        const altName = $this.data('bont-alt')?.toLowerCase() || '';
        const normalizedAltName = altName.replace(/( |\/|\\)/g, '-').replace(/[^\w-]/g, '');

        if (normalizedAltName === selectedVariant) {
          $this.css({
            'z-index': isMybonts ? 'auto' : '1',
            'opacity': '1'
          });
          mainImageFound = true;
          return false;
        }
      });

      if (!mainImageFound) {
        const $firstImage = this.$images.first();
        $firstImage.css({
          'z-index': isMybonts ? 'auto' : '1',
          'opacity': '1'
        });
      }
    },

    _getSelectedVariant: function () {
      const selectedOption = $('input[type="radio"][name="Color"]:checked').val() || "";
      return this._normalizeVariantName(selectedOption);
    },

    _normalizeVariantName: function (name) {
      return name ? name.toLowerCase().replace(/( |\/|\\)/g, '-').replace(/[^\w-]/g, '') : '';
    },

    _displaySelectedOptionImages: function () {
      $('.overlay-image').remove();

      $('select.mw-option__control option:selected').each((index, element) => {
        const valueId = $(element).val();
        if (!valueId || valueId.startsWith('v_') === false) return;

        const $media = $(`.mw-option__media[data-value-id="${valueId}"]:not(.mw-hidden)`);
        const $img = $media.find('img');

        if ($img.length > 0) {
          let src = $img.attr('src');
          if (!src) return;

          // Strip ?width=... from image
          src = src.split('?')[0];

          const productTags = window.productTags || [];
          const isMybonts = productTags.includes('image-swap-mybonts');
          const isSwapOrder = productTags.includes('image-swap-order');
          const overlayZIndex = (isMybonts || isSwapOrder) ? 20 + index : 20 - index;

          this._createOverlayImage(src, overlayZIndex);
        } else {
          console.warn('No matching swatch image found for option value ID:', valueId);
        }
      });
    },

    _createOverlayImage: function (src, zIndex) {
      if (!src || src.trim() === "") return;

      const overlayImage = document.createElement('img');
      overlayImage.className = 'overlay-image';
      overlayImage.src = src;
      overlayImage.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: ${zIndex};
        opacity: 1;
        pointer-events: none;
      `;

      const container = document.querySelector('.bont-product-media-container');
      if (container) {
        container.appendChild(overlayImage);
      } else {
        console.warn('Product media container not found for overlay image injection');
      }
    },

    _logSelectedMwApoVariant: function () {
      $('input[type="radio"][name^="mw_opts"]:checked, select[name^="mw_opts"] option:selected').each((index, element) => {
        const valueId = $(element).val();
        console.debug('Selected APO Option:', valueId);
      });
    },
  };

  $(document).ready(function () {
    window.imageSwap.initialise();
  });
})();
